import { memo, useState } from "react";
import { Droppable } from "react-beautiful-dnd";
import styles from "./QuestionsMenu.module.css";
import Break from "../QuestionTypes/Break/Break";
import MultiOption from "../QuestionTypes/MultiOption/MultiOption";
import ShortAnswer from "../QuestionTypes/ShortAnswer/ShortAnswer";
import MultiDropdown from "../QuestionTypes/MultiDropdown/MultiDropdown";
import Text from "../QuestionTypes/Text/Text";
import ProvinceAndCity from "../QuestionTypes/ProvinceAndCity/ProvinceAndCity";
import DatePicker from "../QuestionTypes/DatePicker/DatePicker";
import MultiText from "../QuestionTypes/MultiText/MultiText";
import { Input } from "antd";
import MediaManager from "../QuestionTypes/Media/Media";

const QuestionsMenu = ({ className, collapse }) => {
  const [filter, setFilter] = useState("");

  return (
    <>
      {collapse && (
        <Droppable droppableId="questions">
          {(provided) => {
            return (
              <div className={[styles.QuestionsMenu, className].join(" ")}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "space-around",
                  }}
                >
                  <h1 className={styles.QuestionsMenuTitle}>سوالات</h1>
                  <Input
                    placeholder="فیلتر نوع سوالات"
                    onChange={(e) => setFilter(e.target.value)}
                    value={filter}
                  />
                </div>

                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    paddingBottom: "1rem",
                    flexWrap: "wrap",
                  }}
                ></div>
                <div
                  className={styles.FlagsContainer}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {[
                    <Text
                      formContainer={false}
                      disabled
                      index={0}
                      id="html"
                      title="متن"
                    />,
                    <MediaManager
                      formContainer={false}
                      disabled
                      index={0}
                      id="image"
                      title="مدیا"
                    />,
                    <Break
                      formContainer={false}
                      disabled
                      index={1}
                      id="break"
                      title="جدا کننده"
                    />,
                    <MultiOption
                      formContainer={false}
                      disabled
                      index={2}
                      id="radio"
                      title="چند گزینه ای"
                    />,
                    <ShortAnswer
                      formContainer={false}
                      disabled
                      index={4}
                      id="text"
                      title="پاسخ نوشتاری"
                    />,
                    <MultiText
                      formContainer={false}
                      disabled
                      index={6}
                      id="multitext"
                      title="چند متن"
                    />,
                    <MultiDropdown
                      formContainer={false}
                      disabled
                      index={6}
                      id="multidropdown"
                      title="چند لیست کشویی"
                    />,
                    <ProvinceAndCity
                      formContainer={false}
                      disabled
                      index={3}
                      id="city"
                      title="شهر و استان"
                    />,
                    <DatePicker
                      formContainer={false}
                      disabled
                      index={7}
                      id="date"
                      title="تاریخ"
                    />,
                  ]
                    .filter((e) => {
                      if (!filter) return true;
                      const title = `${e.props.title}`;
                      return title.search(filter?.trim()) !== -1;
                    })
                    .map((el) => el)}
                </div>
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>
      )}
    </>
  );
};
export default memo(QuestionsMenu);
